module.exports = __webpack_public_path__ + "static/media/lady-infographic.5f08c819.png";